module.exports = __webpack_public_path__ + "static/media/lightning-cors.ffe4b952.gif";